export default __webpack_public_path__ + "static/wng-logo-c77cec277d1933e4e8e16b778182ad89.png";